import { Injectable } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import _ from 'lodash';
import { Paso3 } from 'src/app/global/interfaces/paso-3';
import { Product } from 'src/app/view-model/components/shopping-cart/product';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { environment } from '../../../../../environments/environment';
import { LocalStorageService } from '../../../services/localstorage.service';
import { TagManagerService } from '../../../services/tag-manager.service';

import { AddShippingInfoEventGTM, AddToCartEventGTM, BeginChekoutEventGTM, EventEcommerceGTM, EventGTM, InteraccionEventGTM, PageViewEventGTM, PurchaseEventGTM, ViewCartEventGTM } from './models/tag-manager.models';
const env = environment;

@Injectable()
export class TagManagerGA4Provider extends TagManagerService {

  constructor(
    private storageServ: LocalStorageService,
    private carroService: CarroComprasService,
    private googleTagManagerService: GoogleTagManagerService
  ) {
    super();
  }

  logError(paso: string, errorMessage: string, desc: string) {
 
    const bodyTag = {
      event: 'evento-interactivo',
      'evento-interactivo-categoria': 'Checkout - ' + paso,
      'evento-interactivo-accion': 'error',
      'evento-interactivo-etiqueta': desc
    };
    this.sendTag(bodyTag);
  }

  logAgregarProducto(option: string) {
    let currentPage = 'Paso 1';
    switch (this.storageServ.getCurrentPage()) {
      case env.localStorage.PASO_1:
        currentPage = 'Paso 1';
        break;
      case env.localStorage.PASO_2:
        currentPage = 'Paso 2';
        break;
      case env.localStorage.PASO_3:
        currentPage = 'Paso 3';
        break;
      default: currentPage = 'Paso 1';
    }

    const bodyTag = {
      event: 'evento-interactivo',
      'evento-interactivo-categoria': 'Checkout - ' + currentPage,
      'evento-interactivo-accion': 'click',
      'evento-interactivo-etiqueta': option
    };

    this.sendTag(bodyTag);
  }

  logEliminarProducto(product: Product) {
    let currentPage = 'Paso 1';
    switch (this.storageServ.getCurrentPage()) {
      case env.localStorage.PASO_1:
        currentPage = 'Paso 1';
        break;
      case env.localStorage.PASO_2:
        currentPage = 'Paso 2';
        break;
      case env.localStorage.PASO_3:
        currentPage = 'Paso 3';
        break;
      default: currentPage = 'Paso 1';
    }

    const cantidad = Number(_.get(product, 'cantidad', '1') === '' ? '1' : _.get(product, 'cantidad', '1'));
    const amount = _.get(product, 'amount') === null ? '0' : _.get(product, 'amount', '0').replace('.', '');
    let price = 0;
    if (amount > 0) {
        price = amount / cantidad;
    }
    const bodyTag = {
      event: 'remover-carro',
      ecommerce: {
        remove: {
          actionField: {
            list: currentPage
          },
          products: [{
            category: product.etiquetaVenta ? 'Venta' : 'Arriendo',
            name: product.title,
            id: product.codigoProducto,
            price,
            quantity: cantidad,
            variant: !product.tipoConexion ? 'default' : product.tipoConexion
          }]
        }
      }
    };

    this.sendTag(bodyTag);
  }

  logDL_datosPersonales() {

    const bodyTag = {
      event: 'opciones contratacion',
      ecommerce: {
        checkout_option: {
          actionField: {
            step: 2,
            option: 'completa datos personales'
          }
        }
      }
    };

   this.sendTag(bodyTag);
  }

  logDL_datosSocios() {
    const bodyTag = {
      event: 'opciones contratacion',
      ecommerce: {
        checkout_option: {
          actionField: {
            step: 2,
            option: 'completa datos socios'
          }
        }
      }
    };

    this.sendTag(bodyTag);
  }

  logDL_completa_datos() {
    console.log("logDL_completa_datos")
    // Se deben traer valores de producto
    const product = this.carroService.getCurrentProduct();
    if (product) {
      const cantidad = Number(_.get(product, 'cantidad', '1') === '' ? '1' : _.get(product, 'cantidad', '1'));
      const amount = _.get(product, 'amount', '0') === null ? '0' : _.get(product, 'amount', '0').replace('.', '');
      let price = 0;
      if (amount > 0) {
        price = amount / cantidad;
      }
      // (<any>window).dataLayer = [];
      // (<any>window).dataLayer.push({
      //   event: 'proceso-contratacion',
      //   ecommerce: {
      //     checkout: {
      //       actionField: {
      //         step: 2,
      //         option: 'Persona Natural'
      //       }
      //     },
      //     products: [{
      //       category: _.get(product, 'etiquetaVenta', false) ? 'Venta' : 'Arriendo',
      //       name: product.title,
      //       quantity: cantidad,
      //       variant: !product.tipoConexion ? 'default' : product.tipoConexion
      //     }]
      //   }
      // });


      const bodyTag = {
        event: 'proceso-contratacion',
        ecommerce: {
          checkout: {
            actionField: {
              step: 2,
              option: 'Persona Natural'
            },
            products: [{
              category: _.get(product, 'etiquetaVenta', false) ? 'Venta' : 'Arriendo',
              name: product.title,
              id: product.codigoProducto,
              price,
              quantity: cantidad,
              variant: !product.tipoConexion ? 'default' : product.tipoConexion
            }]
          }
        }
      };

      this.sendTag(bodyTag);
    }
  }

  logDL_inicioActividades(actEconomic: boolean) {
    // Seteo de variables para dataLayer
    let actividadEconomica = 'SI';
    if (actEconomic === false) {
      actividadEconomica = 'NO';
    }

    const bodyTag = {
      event: 'opciones contratacion',
      ecommerce: {
        checkout_option: {
          actionField: {
            step: 2,
            option: 'inicio actividades ' + actividadEconomica
          }
        }
      }
    };

   this.sendTag(bodyTag);
  }

  logDL_adjuntarDocumentos() {

    const bodyTag = {
      event: 'opciones contratacion',
      ecommerce: {
        checkout_option: {
          actionField: {
            step: 2,
            option: 'adjunta documentos'
          }
        }
      }
    };

   this.sendTag(bodyTag);
  }

  logDL_cuentaAbono(esCuentaPropia: boolean) {
    // Se deben traer valores de producto
    const product = this.carroService.getCurrentProduct();
    const cantidad = Number(_.get(product, 'cantidad', '1') === '' ? '1' : _.get(product, 'cantidad', '1'));
    const amount = _.get(product, 'amount', '0') === null ? '0' : _.get(product, 'amount', '0').replace('.', '');
    let price = 0;
    if (amount > 0) {
        price = amount / cantidad;
    }

    const bodyTag = {
      event: 'proceso-contratacion',
      ecommerce: {
        checkout: {
          actionField: {
            step: 3,
            option: esCuentaPropia ? 'Cuenta propia' : 'Cuenta tercero'
          },
          products: [{
            category: product.etiquetaVenta ? 'Venta' : 'Arriendo',
            name: product.title,
            id: product.codigoProducto,
            price,
            quantity: cantidad,
            variant: !product.tipoConexion ? 'default' : product.tipoConexion
          }]
        }
      }
    };

   this.sendTag(bodyTag);
  }

  logDL_cofiguracionProducto(producto: Product, configProductos: any) {
    const limite = _.get(configProductos.get('rangoHasta'), 'value', null);
    // (<any>window).dataLayer = [];
    // (<any>window).dataLayer.push({
    //   event: 'opciones contratacion',
    //   ecommerce: {
    //     checkout_option: {
    //       actionField: {
    //         step: 2,
    //         option: 'configura producto - ' + producto.title + (limite ? (' - ' + limite) : '')
    //       }
    //     }
    //   }
    // });
    const bodyTag = {
      event: 'opciones contratacion',
      ecommerce: {
        checkout_option: {
          actionField: {
            step: 2,
            option: 'configura producto - ' + producto.title + (limite ? (' - ' + limite) : '')
          }
        }
      }
    };

   this.sendTag(bodyTag);
  }

  logDiaEntrega() {
    // (<any>window).dataLayer = [];
    // (<any>window).dataLayer.push({
    //   event: 'opciones contratacion',
    //   ecommerce: {
    //     checkout_option: {
    //       actionField: {
    //         step: 3,
    //         option: 'modifica día entrega'
    //       }
    //     }
    //   }
    // });
    const bodyTag = {
      event: 'opciones contratacion',
      ecommerce: {
        checkout_option: {
          actionField: {
            step: 3,
            option: 'modifica día entrega'
          }
        }
      }
    };

    this.sendTag(bodyTag);
  }

  logCuotas() {
    // (<any>window).dataLayer = [];
    // (<any>window).dataLayer.push({
    //   event: 'opciones contratacion',
    //   ecommerce: {
    //     checkout_option: {
    //       actionField: {
    //         step: 3,
    //         option: 'elimina cuotas transbank'
    //       }
    //     }
    //   }
    // });
    const bodyTag = {
      event: 'opciones contratacion',
      ecommerce: {
        checkout_option: {
          actionField: {
            step: 3,
            option: 'elimina cuotas transbank'
          }
        }
      }
    };

    this.sendTag(bodyTag);
  }

  logEditaCuentaAbono() {
    // (<any>window).dataLayer = [];
    // (<any>window).dataLayer.push({
    //   event: 'opciones contratacion',
    //   ecommerce: {
    //     checkout_option: {
    //       actionField: {
    //         step: 3,
    //         option: 'edita cuenta deposito'
    //       }
    //     }
    //   }
    // });
    const bodyTag = {
      event: 'opciones contratacion',
      ecommerce: {
        checkout_option: {
          actionField: {
            step: 3,
            option: 'edita cuenta deposito'
          }
        }
      }
    };

    this.sendTag(bodyTag);
  }

  logPagarOrden() {
    // (<any>window).dataLayer = [];
    // (<any>window).dataLayer.push({
    //   event: 'opciones contratacion',
    //   ecommerce: {
    //     checkout_option: {
    //       actionField: {
    //         step: 3,
    //         option: 'Pagar orden'
    //       }
    //     }
    //   }
    // });
    const bodyTag = {
      event: 'opciones contratacion',
      ecommerce: {
        checkout_option: {
          actionField: {
            step: 3,
            option: 'Pagar orden'
          }
        }
      }
    };

    this.sendTag(bodyTag);
  }

  logCierre(idSS: string) {
    const product = this.carroService.getCurrentProduct();
    const cantidad = Number(_.get(product, 'cantidad', '1') === '' ? '1' : _.get(product, 'cantidad', '1'));
    const amount = _.get(product, 'amount', '0') === null ? '0' : _.get(product, 'amount', '0').replace('.', '');
    let price = 0;
    let revenue = 0;
    if (amount > 0) {
        price = amount / cantidad;
        revenue = Number(amount);
    }
    // (<any>window).dataLayer = [];
    // (<any>window).dataLayer.push({
    //   event: 'opciones contratacion',
    //   ecommerce: {
    //     purchase: {
    //       actionField: {
    //         id: idSS
    //       }
    //     },
    //     products: [{
    //       name: product.title,
    //       category: product.etiquetaVenta ? 'Venta' : 'Arriendo',
    //       variant: !product.tipoConexion ? 'default' : product.tipoConexion,
    //       quantity: cantidad
    //     }]
    //   }
    // });

    const bodyTag = {
      event: 'contratacion',
      ecommerce: {
        purchase: {
          actionField: {
            id: idSS,
            revenue
          },
          products: [{
            name: product.title,
            id: product.codigoProducto,
            price,
            category: product.etiquetaVenta ? 'Venta' : 'Arriendo',
            variant: !product.tipoConexion ? 'default' : product.tipoConexion,
            quantity: cantidad
          }]
        }
      }
    };

    this.sendTag(bodyTag);
  }

  logPaso3(dataPaso3: Paso3, tipoPersona: boolean){
    const product = this.carroService.getCurrentProduct();
    const cantidad = Number(_.get(product, 'cantidad', '1') === '' ? '1' : _.get(product, 'cantidad', '1'));
    const amount = _.get(product, 'amount', '0') === null ? '0' : _.get(product, 'amount', '0').replace('.', '');
    let price = 0;
    let revenue = 0;
    if (amount > 0) {
        price = amount / cantidad;
        revenue = Number(amount);
    }

    const bodyTag = {
      event: 'proceso-contratacion',
      ecommerce: {
        checkout: {
          actionField: {
            step: 3,
            option: dataPaso3.dataCuentaAbono.tipoPropietario === "PROPIA" ? 'Cuenta propia' : 'Cuenta tercero',
            tipoPersona: tipoPersona ? "Persona Natural" : "Persona Jurídica"
          },
          products: [{
            category: product.etiquetaVenta ? 'Venta' : 'Arriendo',
            name: product.title,
            id: product.codigoProducto,
            price,
            quantity: cantidad,
            variant: 'default'
          }]
        }
      }
    };

    this.sendTag(bodyTag);

  }

  logResumenPago(dataPaso3: Paso3, tipoPersona: boolean){
    const product = this.carroService.getCurrentProduct();
    const cantidad = Number(_.get(product, 'cantidad', '1') === '' ? '1' : _.get(product, 'cantidad', '1'));
    const amount = _.get(product, 'amount', '0') === null ? '0' : _.get(product, 'amount', '0').replace('.', '');
    let price = 0;
    let revenue = 0;
    if (amount > 0) {
        price = amount / cantidad;
        revenue = Number(amount);
    }

    const bodyTag = {
      event: 'proceso-contratacion',
      ecommerce: {
        checkout: {
          actionField: {
            step: 4,
            option: dataPaso3.dataCuentaAbono.tipoPropietario === "PROPIA" ? 'Cuenta propia' : 'Cuenta tercero',
            tipoPersona: tipoPersona ? "Persona Natural" : "Persona Jurídica"
          },
          products: [{
            category: product.etiquetaVenta ? 'Venta' : 'Arriendo',
            name: product.title,
            id: product.codigoProducto,
            price,
            quantity: cantidad,
            variant: 'default'
          }]
        }
      }
    };

    this.sendTag(bodyTag);

  }
  
  /**
   *  "event": "page-view"
   * @param pageView 
   */
   public logPageView(event:EventGTM):void{      
    const bodyTag = {
      "event":event.event,
      "page":event.page,
      "tipo-flujo":event.tipoFlujo,
      "origen":this.storageServ.getPaso0().utm
    };
    this.sendTag(bodyTag);
  }


  logEventInteraciones(event:InteraccionEventGTM):void{    
    if(this.storageServ.getPaso1()){
      event.setIsPersonaNatural(this.storageServ.getPaso1().currentIsPersonaNatural);
    }
    const tag = event.getTag?event.getTag():undefined;
    if(tag){
    this.sendTag(tag);
    return
    }
    this.sendTag({
            "event": event.event,
            "evento-interactivo-categoria":event.getCategoria().toLowerCase(),
            "evento-interactivo-accion":event.getAccion().toLowerCase(),
            "evento-interactivo-etiqueta":event.getEtiqueta().toLowerCase() , 
            "tipo-persona":event.tipoPersona.toLowerCase(),
            "page": event.page,
            "tipo-flujo": event.tipoFlujo
      });      
  }




  logCategoriaEcommerce(event:EventGTM):void{
    const eventEcommerce = <EventEcommerceGTM>event;
    const ecommerce = eventEcommerce.productToEcommerce(this.carroService.getCurrentProduct());
    if(this.storageServ.getPaso1()){
      event.setIsPersonaNatural(this.storageServ.getPaso1().currentIsPersonaNatural);
    }
    this.sendTag({ ecommerce: null });
    this.sendTag({ 
            "event": event.event,
            "evento-interactivo-categoria":'ecommerce',
            "evento-interactivo-accion": event.getAccion().toLowerCase(),
            "evento-interactivo-etiqueta": event.getEtiqueta().toLowerCase(), 
            "page": event.page, 
            "step": event.step, 
            "tipo-persona":event.tipoPersona,
            "tipo-flujo": event.tipoFlujo,
            "ecommerce": ecommerce,
            "origen": event.origen ? event.origen  : null
            });   

  }

  logCategoriaEcommerceAddToCart(event:EventGTM):void{
    const eventEcommerce = <EventEcommerceGTM>event;
    const ecommerce = eventEcommerce.productToEcommerce(this.carroService.getCurrentProduct());

    this.sendTag({ ecommerce: null });
    this.sendTag({ 
            "event": event.event,
            "evento-interactivo-categoria":'ecommerce',
            "evento-interactivo-accion": event.getAccion().toLowerCase(),
            "evento-interactivo-etiqueta": event.getEtiqueta().toLowerCase(), 
            "page": event.page,  
            "tipo-flujo": event.tipoFlujo,
            "ecommerce": ecommerce,
            "origen": event.origen ? event.origen  : null
            });   

  }

  logEvent(event:EventGTM):void{
    switch (event.constructor) {
      case InteraccionEventGTM:
        this.logEventInteraciones(event as InteraccionEventGTM);
        break
      case BeginChekoutEventGTM:
      case AddShippingInfoEventGTM:
      case PurchaseEventGTM:  
      case ViewCartEventGTM:
        this.logCategoriaEcommerce(event);
        break
      case PageViewEventGTM:
        this.logPageView(event);
        break
      case AddToCartEventGTM:
          this.logCategoriaEcommerceAddToCart(event);
          break
      default:
        console.log('Unknown object...');

    }
  }

  private sendTag(bodyTag: any): void {
    this.googleTagManagerService.pushTag(bodyTag);
  }

}
